import { useWeb3React } from '@web3-react/core';
import React from 'react';
import textFooter from 'resources/images/text-footer.png';
import { socialLinks } from 'pages/layout/socials';
function FooterComponent() {
  const { account } = useWeb3React();
  return (
    <div className="footer">
      <div className="container">
      {
          !account ?(
            <>
            <ul className="social">
            {socialLinks.map(({ name, icon, link,bg }: any) => (
              <li className="social__icon" key={name}>
                  <a href={link} target="_blank" rel="noopener noreferrer">
                    <img src={bg} alt={name} />
                  </a>
             
              </li>
            ))}
          </ul>
          <span className="copyright"><img src={textFooter} alt="" /></span>
          </>
          ):(
            <span className="copyright text-footer"><img src={textFooter} alt="" /></span>
          )
        }
       
      </div>
    </div>
  );
}

export default FooterComponent;
